import { Component, OnInit } from '@angular/core';
import { NovedadService } from 'src/app/services/novedad.service';
import { Novedad } from 'src/app/models/novedad.model';
import { Categoria } from 'src/app/models/categoria.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss']
})
export class NewComponent implements OnInit {
  constructor(private novedadService: NovedadService,
    private route: ActivatedRoute,
    private router: Router) { }

  novedades: Novedad [];
  categoria: Categoria;

  ngOnInit() {
    this.getNovedadesPerPage();

  }

  getNovedadesPerPage() {
    this.novedadService.getNovedadPerPage().subscribe(
      data => {
        this.novedades = data.data;
      }
    );
  }




}
